import {BaseModel} from '../base/BaseModel';

/**
 * @class PermissionModel
 * @extends BaseModel
 *
 * @property {object} attributes
 * @property {string<FARM>} attributes.objectType - Types of objects permission is applied to
 * @property {string} attributes.objectUuid - Uuid of the object to which permission level is applied
 * @property {string} attributes.granteeUuid - Uuid of user who received the permission>
 * @property {string} attributes.granterUuid - Uuid of user who gave the permission
 * @property {string<DISTRIBUTOR_READ|READ|WRITE|SHARE>} attributes.access - Permission types @see {UserModel.ACCESS_LEVEL}
 */
export class PermissionModel extends BaseModel {

    initialize () {

        this.microservice = 'users';
        this.resource = 'permissions';
    }

    get idAttribute () {

        return 'uuid';
    }

    get defaults () {

        return {
            objectType: undefined,
            objectUuid: undefined,
            granteeUuid: undefined,
            granterUuid: undefined,
            access: undefined,
            uuid: undefined
        };
    }

    static get OBJECT_TYPE () {

        return {
            FARM: 'FARM'
        };
    }
}


// WEBPACK FOOTER //
// ./shared/model/users/PermissionModel.js